import BaseToastNotification from '#BASE/components/notification/toastNotification.component';

export default {
    mixins: [
        BaseToastNotification,
    ],
    computed: {
        userName() {
            return this.$store.state.userinfo.userName;
        },
    },
    methods: {
        add(list) {
            if(list.lionKing == this.userName) {
                return;
            }
            
            this.queue = this.queue.concat(list);

            if (!this.running) {
                this.show();
            }
        },        
    },    
};